<template>
  <div class="about">
    <Menu></Menu>
    <HelloWorld v-show="true"/>
<!--
    <template>
      <v-row justify="center">
        <v-dialog
            v-model="dialog"
            persistent
            max-width="290"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
            >
              Open Dialog
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="headline">
              Use Google's location service?
            </v-card-title>
            <v-card-text>{{query}}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  text
                  @click="dialog = false"
              >
                Disagree
              </v-btn>
              <v-btn
                  color="green darken-1"
                  text
                  @click="dialog = false"
              >
                Agree
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>  </div>
-->
  </div>
</template>

<script>
import Menu from '@/components/Menu.vue'
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: "about",
  data () {
    return {
      dialog: false,
      query: 'Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.'
    }
  },
  components: {
    Menu,
    HelloWorld,
  }
}
</script>
